import service from "@/api/service";
import { BookingUserCSVGetRequest } from "@/api/analysis/booking-user-csv/request";
import { DownloadCSVResponse } from "@/api/response";

/**
 * 予約ユーザーCSV出力APIをコールします。
 *
 * @param getRequest 予約ユーザーCSV出力APIのリクエストボディ
 * @return response
 */
export async function get(getRequest: BookingUserCSVGetRequest) {
  const response = await service.postReceiveCSV(
    "/analysis-booking-user-csv",
    getRequest
  );
  return response as DownloadCSVResponse;
}
